module.exports = __webpack_public_path__ + "static/img/program_07.8dbb548.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/program_07.jpg
// module id = vP8n
// module chunks = 0